import { render, staticRenderFns } from "./VirologyResults.vue?vue&type=template&id=ffde8b20&"
import script from "./VirologyResults.vue?vue&type=script&lang=ts&"
export * from "./VirologyResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_locales/VirologyResults.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fvirology%2FVirologyResults.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports